import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from '../Services/auth.service';

@Injectable()

export class AuthGuard implements CanActivate {
    constructor(private _auth: AuthService, public _router: Router) {}

    canActivate(): boolean {
        if (this._auth.isAuthenticated) { return true; }
        this._router.navigate(['/']);
        return false;
    }
}